import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import gql from 'graphql-tag';

const CHECK_CLIENT_FROM_EXCEL = gql`
  mutation CheckClientFromExcel($fullName: String, $idNumber: String, $entityName: String) {
    checkClientFromExcel(fullName: $fullName, idNumber: $idNumber, entityName: $entityName) {
      id
      fullName
      idNumber
      entityName
      tfsMatch
      googleResults
      googleError
      timestamp
    }
  }
`;

const ClientCheckForm = ({ onSearchResult, onDownloadPDF }) => {
  const [fullName, setFullName] = useState('');
  const [idNumber, setIdNumber] = useState('');
  const [entityName, setEntityName] = useState('');
  const [searchResult, setSearchResult] = useState(null);
  const [checkClientFromExcel, { loading, error }] = useMutation(CHECK_CLIENT_FROM_EXCEL);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fullName && !idNumber && !entityName) {
      alert('Please fill in at least one field (Full Name, ID Number, or Entity Name).');
      return;
    }

    try {
      const { data: result } = await checkClientFromExcel({
        variables: { fullName: fullName || null, idNumber: idNumber || null, entityName: entityName || null }
      });
      setSearchResult(result.checkClientFromExcel);
      if (onSearchResult) onSearchResult(result.checkClientFromExcel);
      console.log('Search Result:', result.checkClientFromExcel);
    } catch (err) {
      console.error('Check Client Error:', err);
      alert('Error processing request: ' + err.message);
    }
  };

  const handleClear = () => {
    setFullName('');
    setIdNumber('');
    setEntityName('');
    setSearchResult(null);
    if (onSearchResult) onSearchResult(null);
  };

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-md mx-auto">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">Check Client</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 font-medium mb-1">Full Name:</label>
          <input
            type="text"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-1">ID Number:</label>
          <input
            type="text"
            value={idNumber}
            onChange={(e) => setIdNumber(e.target.value)}
            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-gray-700 font-medium mb-1">Entity Name:</label>
          <input
            type="text"
            value={entityName}
            onChange={(e) => setEntityName(e.target.value)}
            className="w-full p-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex space-x-4">
          <button
            type="submit"
            disabled={loading}
            className="flex-1 bg-blue-600 text-white p-2 rounded-md hover:bg-blue-700 disabled:bg-gray-400"
          >
            {loading ? 'Checking...' : 'Check Client'}
          </button>
          <button
            type="button"
            onClick={handleClear}
            className="flex-1 bg-gray-500 text-white p-2 rounded-md hover:bg-gray-600"
          >
            Clear
          </button>
        </div>
        {error && <p className="text-red-500 mt-2">{error.message}</p>}
      </form>
      {searchResult && (
        <div className="mt-6 space-y-2">
          {searchResult.fullName && <p><strong>Full Name:</strong> {searchResult.fullName}</p>}
          {searchResult.idNumber && <p><strong>ID Number:</strong> {searchResult.idNumber}</p>}
          {searchResult.entityName && <p><strong>Entity Name:</strong> {searchResult.entityName}</p>}
          <p>
            <strong>TFS Match:</strong>{' '}
            <span className={searchResult.tfsMatch ? 'text-red-600' : 'text-green-600'}>
              {searchResult.tfsMatch ? 'MATCH FOUND' : 'NO MATCH FOUND'}
            </span>
          </p>
          <h3 className="text-xl font-medium text-gray-800 mt-4 mb-2">Google Search Results:</h3>
          {searchResult.googleError ? (
            <p className="text-red-500">Failed to fetch results: {searchResult.googleError}</p>
          ) : searchResult.googleResults.length > 0 ? (
            <ul className="list-disc pl-5 space-y-2">
              {searchResult.googleResults.map((result, index) => {
                const [title, url] = result.split(': ');
                return (
                  <li key={index}>
                    {title}:{' '}
                    <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      {url}
                    </a>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p className="text-gray-600">No Google search results found.</p>
          )}
          <button
            onClick={() => onDownloadPDF(searchResult.id)}
            className="mt-4 bg-green-600 text-white p-2 rounded-md hover:bg-green-700"
          >
            Download PDF
          </button>
        </div>
      )}
    </div>
  );
};

export default ClientCheckForm;